import * as req from 'api/actions';
import * as c from './constants';

export const dummy = () => {};

export const getList = (payload = {}, callback) =>
  req.list(
    c.LIST,
    'api/v1/administrators/reports/transaction_histories',
    payload,
    callback
  );

export const upload = (payload = {}, callback) =>
  req.upload(
    c.UPLOAD,
    'api/v1/administrators/rpt_billing_imports/upload_csv',
    payload,
    callback
  );
